<template>
    <span class="Separator">•</span>
</template>

<style scoped lang="scss">
    .Separator {
        color: $Grey-700;

        @include TextStyle(UiMediumRegular);

        @include Breakpoint(Small, Medium) {
            display: none;
        }
    }
</style>